import React from 'react';

import { SectionProps, SectionWithTitleProps } from '../types';
import styles from './styles.module.css';

export const SectionWithTitle: React.FC<SectionWithTitleProps> = ({
  title,
  titleAction,
  children,
}) => {
  return (
    <div className={styles.section} data-testid="sidebar-section">
      <div className={styles.sectionHeader}>
        <h3 data-testid="sidebar-section-title">{title}</h3>
        {titleAction && (
          <div
            className={styles.headerAction}
            data-testid="sidebar-section-action"
          >
            {titleAction}
          </div>
        )}
      </div>
      <div data-testid="sidebar-section-content">{children}</div>
    </div>
  );
};

export const Section: React.FC<SectionProps> = ({ children }) => {
  return (
    <div className={styles.section} data-testid="sidebar-section">
      <div data-testid="sidebar-section-content">{children}</div>
    </div>
  );
};
